import { WSPage } from "@wingspanhq/fe-component-library";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  PAYEES_ALL_PATH,
  PAYEES_ARCHIVED_PATH,
  PAYEES_COMPLETE_PATH,
  PAYEES_INCOMPLETE_PATH,
  PAYEES_NOT_SIGNED_UP_PATH
} from "../../utils";
import { RoutePayees } from "../RoutePayees";
import { AlertExpiringRequirements } from "../RoutePayees/AlertExpiringRequirements";
import { DashboardHeader } from "./DashboardHeader";
import { DashboardTabs } from "./DashboardTabs";

export const RoutePayeesDashboard: React.FC = () => {
  return (
    <WSPage>
      <DashboardHeader />

      <AlertExpiringRequirements />

      <DashboardTabs />

      <Switch>
        <Route
          path={[
            PAYEES_ALL_PATH,
            PAYEES_COMPLETE_PATH,
            PAYEES_INCOMPLETE_PATH,
            PAYEES_ARCHIVED_PATH,
            PAYEES_NOT_SIGNED_UP_PATH
          ]}
          component={RoutePayees}
        />

        <Redirect to={PAYEES_ALL_PATH} />
      </Switch>
    </WSPage>
  );
};
